import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import Hero from '@/pages/home/components/Hero';
import HotTicker from '@/pages/home/components/HotTicker';
import VerdictGuide from '@/pages/home/components/VerdictGuide';
import RankingSection from '@/pages/home/components/RankingSection';
import CategorySection from '@/pages/home/components/CategorySection';
import PrinciplesSection from '@/pages/home/components/PrinciplesSection';
import FaqSection from '@/pages/home/components/FaqSection';
import SubscribeSection from '@/pages/home/components/SubscribeSection';
import { useSeo } from '@/hooks/useSeo';
import { faqs, site } from '@/mocks/site';

export default function Home() {
  useSeo({
    title: '看料爆料 · 热料真假核实、实锤追踪与辟谣情报站',
    description:
      '看料爆料专注网络热料的真假核实，提供看料爆料实锤证据、辟谣回应与核实记录，附可信度评分，帮你判断一条料值不值得信，少被带节奏。',
    keywords: '看料爆料,看料爆料真假,看料爆料实锤,看料爆料辟谣,看料爆料核实,看料爆料可信度',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: site.name,
        description: site.intro,
        url: typeof window !== 'undefined' ? window.location.origin : '',
        slogan: site.slogan,
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: site.name,
        url: typeof window !== 'undefined' ? window.location.origin : '',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${typeof window !== 'undefined' ? window.location.origin : ''}/ranking?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((f) => ({
          '@type': 'Question',
          name: f.q,
          acceptedAnswer: { '@type': 'Answer', text: f.a },
        })),
      },
    ],
  });

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <Hero />
        <HotTicker />
        <VerdictGuide />
        <RankingSection />
        <CategorySection />
        <PrinciplesSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}